<template>
  <div style="width:100%;height:330px;" :style="{height:`${cardDataGet.height ? cardDataGet.height : 330}px`}">
    <div v-if="cardDataGet.type!=='placeholder'" :style="{background:cardDataGet.type=='placeholder'?'transparent':'white'}" style="display:flex;flex-direction:column;height:100%;padding: 16px 32px;box-sizing: border-box;border-radius:5px;">
      <div class="left-top-title">{{cardDataGet.title}}</div>
      <div class="bottom-content">
        <el-table
            ref="cardTable"
            v-loading="cardData.loading"
            class="customer-no-border-table"
            :data="cardDataGet.tableData"
            :header-cell-style="headCellStyle"
            :cell-style="cellStyleMethod"
            :height="'100%'"
            :width="'100%'"
            @row-click="rowClick"
        >
          <el-table-column
              v-for="column in cardDataGet.showColoums"
              :prop="column.prop"
              :min-width="columnsMin(column)"
              :show-overflow-tooltip="false"
          >
            <template #header>
              <div>
                {{ column.label.split(':')[0] }}
              </div>
            </template>
            <template #default="scope">
              <div>
                {{ toQfNumber(scope.column.property, scope.row[scope.column.property], scope,column) }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页控制器 -->
        <div style="display:flex;justify-content: right;margin-top: 16px;">
          <div
              v-if="pageConfig.totalCount!==-1"
              style="padding: 2px 5px;line-height: 28px;font-size: 14px;font-family: 'SourceHanSansSC-Regular'">
            共 <span style="color: #1473E3">{{ pageConfig.totalCount.toLocaleString() }}</span> 条数据
          </div>
          <el-pagination v-if="pageConfig.show" background layout="prev, pager, next" @current-change="pageChange"
                         small
                         hide-on-single-page
                         :page-size="pageConfig.pagesize"
                         :current-page="pageConfig.currentPage" :total="pageConfig.totalCount">
          </el-pagination>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import {getPerformance} from "@/api/api";

export default {
  name: "CustomCardTable",
  props:["cardData","filterRequestData","needRefresh"],
  data(){
    return {
      cardDataGet:[],
      pageConfig:{
        show:false,
        totalCount:-1,
        pagesize:10,
        currentPage:1,
      }
      // cardData:{
      //   title:"",
      //   showColoums:[
      //     {
      //       prop:"dept:collaborative_p_dept",
      //       label:"名称:varchar"
      //     },
      //     {
      //       prop:"number:collaborative_p_dept",
      //       label:"订单数:varchar",
      //     },
      //     {
      //       prop:"amount:charge",
      //       label:"金额:varchar",
      //     },
      //     {
      //       prop:"amount:yearonyear",
      //       label:"同比:varchar",
      //     },
      //     {
      //       prop:"amount:chainratio",
      //       label:"环比:varchar",
      //     },
      //   ],
      //   tableData: [{
      //     "dept:collaborative_p_dept": "数字化渠道事业部",
      //     "number:collaborative_p_dept": 15,
      //     "amount:charge":1200000,
      //     "amount:yearonyear":20,
      //     "amount:chainratio":-10
      //   }],
      // }

    }

  },
  mounted() {
    this.cardDataGet = this.cardData
    this.updateCard()
  },

  watch:{
    needRefresh(newValue){
      console.log('needRefresh')
      this.updateCard()
    },
    filterRequestData(newValue){
      // console.log('filterRequestData change，更新cardTable')
      // this.updateCard()

    }
  },
  methods:{
    getCurrentPageDatas(){
      if(this.cardDataGet.type=='placeholder'){
        return
      }
      if(this.cardDataGet.tableDataAll.length > this.pageConfig.pagesize){
        this.cardDataGet.tableData = this.cardDataGet.tableDataAll.slice((this.pageConfig.currentPage-1)*this.pageConfig.pagesize,(this.pageConfig.currentPage)*this.pageConfig.pagesize)
        this.pageConfig.show = true
      }else{
        this.cardDataGet.tableData = this.cardDataGet.tableDataAll
        this.pageConfig.show = false
      }
      console.log('this.cardDataGet.tableData.length',this.cardDataGet.tableDataAll.length)
      this.pageConfig.totalCount = this.cardDataGet.tableDataAll.length
      this.pageConfig.currentPage = 1
      console.log('this.cardDataGet.tableData',this.cardDataGet.tableData)
    },

    pageChange(currentPage){
      console.log('pageChange',currentPage)
      this.pageConfig.currentPage = currentPage;
      this.getCurrentPageDatas()
    },

    updateCard(){
      if(this.cardDataGet.type!=='placeholder'){
        this.getPerformanceData()
      }
    },
    async getPerformanceData(){
      this.pageConfig.totalCount = -1
        this.cardData.loading = true
        let postData = JSON.parse(JSON.stringify(this.filterRequestData))
        // postData.index = `${postData.index}_${this.cardData.key}`
        postData.dimension = this.cardData.key
        console.log('CustomCardTable过滤条件/postData',postData.dimension,postData)
        let res = await getPerformance(postData)
      let resData = res.data.respData
      if(this.cardDataGet.custom){
        console.log('后台获取表头数据模式')
        let column_mapper = resData.cols_mapper
        let showColumnArr  = resData.columns_list
        this.cardDataGet.showColoums = showColumnArr.map(s=> {
          console.log('找的label',s,column_mapper[s])
          let label = column_mapper[s] ? column_mapper[s] : "未知:varchar"
          return {
            prop:s,
            label:label
          }
        })
        console.log('后台获取的表头构造',JSON.stringify(this.cardDataGet.showColoums))
        this.cardDataGet.tableDataAll = resData.data//数据列表
        this.cardDataGet.tableShowColumn = resData
      }else{
        console.log('前端写死表头模式')
        this.cardDataGet.tableDataAll = resData instanceof Array ? resData:[]
      }

        this.getCurrentPageDatas()
        console.log('CustomCardTable过滤条件过滤条件返回结果/filterContent',resData)
      this.$nextTick(()=>{
        this.$refs.cardTable.doLayout()
        this.cardData.loading = false
      })
        // content.total = resData instanceof Array && resData.length ? resData[0].amount : 0

    },

    /**
     * 表格某行点击
     * @param e 点击item数据
     */
    rowClick(e) {
      this.$emit('row-click',e)
    },

    /**
     * 表格头部样式
     * @param row
     * @param column
     * @param rowIndex
     * @param columnIndex
     * @returns {{fontFamily: string, whiteSpace: string, color: string, textAlign: string, background: string, fontSize: string, boxSizing: string, paddingLeft: string, fontWeight: string, height: string}}
     */
    headCellStyle({row, column, rowIndex, columnIndex}) {
      let type = this.cardData.showColoums[columnIndex].label.split(":")[1]
      let fixedHeader = false

        if (type === 'decimal' || type === 'int') {


          return {
            cursor: fixedHeader ? 'no-drop':'grab',
            height: '40px',
            background: 'white',
            textAlign: 'right',
            fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
            color: '#3F464E',
            fontWeight: '600',
            fontSize: '14px',
            paddingLeft: '10px',
            boxSizing: "border-box",
            whiteSpace: "pre"
          }
        } else {
          return {
            cursor: fixedHeader ? 'no-drop':'grab',
            height: '40px',
            background: 'white',
            textAlign: 'left',
            fontFamily: 'SourceHanSansSC-Regular, SourceHanSansSC',
            color: '#3F464E',
            fontWeight: '600',
            fontSize: '14px',
            paddingLeft: '10px',
            boxSizing: "border-box",
            whiteSpace: "pre"
          }
        }

    },

    cellStyleMethod({row, column, rowIndex, columnIndex}) {
      // console.log('cellStyleMethod/row, column, rowIndex, columnIndex',row, column, rowIndex, columnIndex)
      let type = this.cardData.showColoums[columnIndex].label.split(":")[1]
      // console.log('columLabel type',type)
        let fontWeight = 400


        // console.log(type)
        if (type === 'decimal' || type === 'int') {
          return {
            // height: '68px',
            // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
            textAlign: 'right',
            paddingLeft: '10px',
            // fontFamily: 'Helvetica',
            // color: '#3F464E',
            // fontWeight: fontWeight,
            // fontSize: '14px',
            // paddingRight: '10px',
            // paddingLeft: '20px',
            // boxSizing: "border-box",
            // lineHeight: "17px"
          }
        } else {
          return {
            // height: '68px',
            // background: rowIndex%2===0?'#FFFFFF':'#F6F8FB',
            textAlign: 'left',
            paddingLeft: '10px',
            // fontFamily: 'Helvetica',
            // color: '#3F464E',
            // fontWeight: fontWeight,
            // fontSize: '14px',
            // paddingLeft: '20px',
            // boxSizing: "border-box",
            // lineHeight: "17px"
          }
        }

    },

    columnsMin(item) {
      let min = 50
      // console.log('item.prop',item.prop)
      if (item.prop === 'dept:collaborative_p_dept') {
        return '130px'
      }else if (item.prop === 'number:order_count') {
        return '65px'
      }else if (item.prop === 'amount:charge') {
        return '78px'
      }else if (item.prop === 'first_quotation_time'){
        return '56px'
      }else {
        return `${min}px`
      }
    },

    toQfNumber(totype, value, scrop,columData) {
      // console.log('totype',totype,value,scrop,columData)
      let label = columData.label
      let type = label.slice(label.lastIndexOf(':') + 1)
      // console.log('typeValue',type,value)
      if (type === "decimal" || type === 'int') {
        if (value === undefined || !value) {
          return 0
        }

        let nums = Number(value).toFixed(2).toString().split('.')
        nums[0] = parseFloat(nums[0]).toLocaleString()
        return nums.join('.')
      }
      return value
    },
  }
}
</script>

<style scoped lang="scss">
.left-top-title{
  font-size:40px;
  line-height: 40px;
}
.bottom-content{
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: calc(100% - 60px);
  margin-top: 20px;
  width: 100%;
}
.right-item{
  display:flex;
  font-weight: 600;
  .title{
    width:50px;
    text-align: right;
  }

}

</style>

<style lang="scss">

.customer-no-border-table td,.customer-no-border-table.el-table th.is-leaf {
  border:none;
}




.customer-no-border-table::before{
  width: 0;
}

/*去掉鼠标悬停背景颜色*/
.customer-no-border-table.el-table tbody tr:hover>td {
  background-color:#ffffff!important
}

.customer-no-border-table{
  .el-table__row {
    background: #FFFFFF;
    //border: none;

    ////偶数行
    //&:nth-child(2n) {
    //  background: #F6F8FB;
    //}
    ////奇数行
    //&:nth-child(2n+1) {
    //  background: white;
    //}
  }
  .el-table__row>td{
    border:none;
  }
  //.el-table{
  //  td, th.is-leaf {
  //    border:none;
  //  }
  //
  //
  //}


}



</style>

